import Typography from '@mui/material/Typography';
import { motion } from 'framer-motion';
import Badge from '@mui/material/Badge';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';
import IconButton from '@mui/material/IconButton';
import Hidden from '@mui/material/Hidden';

function PageHeader({avatar, title, breadcrumbs, hideBreadcrumbs,
                     onMenuClick, button, buttons, children, unread}) {
  
  return (
    <div className="flex flex-col sm:flex-row item-center space-y-16 sm:space-y-0 pt-16 pb-10 px-24 sm:px-32 w-full border-b-1 items-center justify-between">
      <div className="flex flex-col items-center space-y-12 sm:flex-row sm:space-y-0 sm:space-x-12">
        <div className="flex flex-row items-center space-x-12">
	        {onMenuClick && (
			 <Hidden lgUp>
	          <IconButton
	            onClick={onMenuClick}
	            aria-label="open left sidebar"
	            size="large"
	          >
	            <Badge color="secondary" variant="dot" invisible={!unread}>
	            	<FuseSvgIcon>heroicons-outline:menu</FuseSvgIcon>
		        </Badge> 
	          </IconButton>
	        </Hidden> 
		    )}
	        
	        {avatar}
	        
	        {title && (
			<Typography
	          component={motion.span}
	          initial={{ x: -20 }}
	          animate={{ x: 0, transition: { delay: 0.2 } }}
	          delay={300}
	          className="text-24 lg:text-32 font-extrabold tracking-tight leading-none"
	        >
	          {title}
	        </Typography>		
			)}    
		</div>
		
        {breadcrumbs && !hideBreadcrumbs && (
         <Typography
          component={motion.span}
          initial={{ x: -20 }}
          animate={{ x: 0, transition: { delay: 0.2 } }}
          delay={300}
          className="text-16 md:text-24 font-bold tracking-tight leading-none"
        >
          {breadcrumbs}
        </Typography>	
		)}
         
        {children}
           
      </div>

	  
		
	  {button &&
      <div className="flex items-center -mx-8">
		{button}
      </div>
	  }
	  
	  {buttons &&
      <div className="flex items-center -mx-8">
		{buttons.map((button) => {
			<>{button}</>
		})}
      </div>
	  }
		
    </div>
  );
}

export default PageHeader;
